import React from 'react';
import { Home } from './pages/Home';
interface AppProps {
  defaultPath?: 'decouverte' | 'licencie';
}
export function App({
  defaultPath = 'decouverte'
}: AppProps) {
  return <Home defaultPath={defaultPath} data-id="element-0" data-mp="3k9kt1l5q1n5b" />;
}